export const THANJAVUR_EXPERIENCES_URL =
  'https://app.oorva.in/?state=Tamil+Nadu&district=Thanjavur'

export const COIMBATORE_EXPERIENCES_URL =
  'https://app.oorva.in/?state=Tamil+Nadu&district=Coimbatore'

export const KANCHEEPURAM_EXPERIENCES_URL =
  'https://app.oorva.in/?state=Tamil+Nadu&district=Kancheepuram'

export const WEEKEND_TRIPS_URL = 'https://app.oorva.in/weekend-trips'

export const WEEKEND_TRIP_WHATSAPP_MESSAGE =
  'Hi Oorva! I want to book the Thanjavur weekend trip (Sat/Sun). Please share availability.'

/** Oorva booking WhatsApp number in international format (no +). */
export const WHATSAPP_NUMBER = '918754035228'

export function buildWhatsAppUrl(message: string) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
}

type ContactFields = {
  name: string
  email?: string
  phone?: string
}

function contactLines(data: ContactFields) {
  const lines: string[] = [`Name: ${data.name}`]
  if (data.email?.trim()) lines.push(`Email: ${data.email.trim()}`)
  if (data.phone?.trim()) lines.push(`Phone: ${data.phone.trim()}`)
  return lines
}

export function buildRIIPWhatsAppMessage(
  data: ContactFields & {
    designation: string
    institutionType: string
    institutionName: string
    groupSize?: string
  },
  programmeType: 'riip' | 'cap' = 'riip',
) {
  return [
    `Hi Oorva! I'd like to enquire about the ${programmeType.toUpperCase()} programme.`,
    '',
    `Institution: ${data.institutionName} (${data.institutionType})`,
    `Designation: ${data.designation}`,
    data.groupSize?.trim() ? `Group size: ${data.groupSize.trim()}` : null,
    '',
    ...contactLines(data),
    '',
    `Please get back to me with next steps.`,
  ]
    .filter((line): line is string => line !== null)
    .join('\n')
}

export function buildMerchWhatsAppMessage(
  data: ContactFields & {
    quantity: string
    eventType: string
    message?: string
  },
) {
  return [
    `Hi Oorva! I'd like to enquire about the Experience Calendar.`,
    '',
    `Quantity: ${data.quantity}`,
    `Buying for: ${data.eventType}`,
    data.message?.trim() ? `Message: ${data.message.trim()}` : null,
    '',
    ...contactLines(data),
    '',
    `Please confirm stock and payment details.`,
  ]
    .filter((line): line is string => line !== null)
    .join('\n')
}

export function buildHostWhatsAppMessage(
  data: ContactFields & { district: string; category: string },
) {
  return [
    `Hi Oorva! I'd like to apply as a host.`,
    '',
    `District: ${data.district}`,
    `Category: ${data.category}`,
    '',
    ...contactLines(data),
    '',
    `Please get back to me about onboarding.`,
  ].join('\n')
}

export function buildBookExperienceWhatsAppMessage(
  data: ContactFields & {
    district: string
    datesNotDecided: boolean
    preferredDates?: Date
    groupSize: string
    groupType?: string
  },
) {
  const dateLabel = data.datesNotDecided
    ? 'Not decided'
    : (data.preferredDates?.toDateString() ?? 'Not provided')
  return [
    `Hi Oorva! I'd like to book an experience.`,
    '',
    `District: ${data.district}`,
    `Preferred date: ${dateLabel}`,
    `Group size: ${data.groupSize}`,
    data.groupType ? `Group type: ${data.groupType}` : null,
    '',
    ...contactLines(data),
    '',
    `Please get back to me to confirm availability.`,
  ]
    .filter((line): line is string => line !== null)
    .join('\n')
}

export function buildTourOperatorWhatsAppMessage(data: {
  name: string
  company: string
  niches: string[]
}) {
  return [
    `Hi Oorva! I'm ${data.name.trim()} from ${data.company.trim()}. I just registered interest as a travel partner.`,
    data.niches.length ? '' : null,
    data.niches.length ? `Our focus: ${data.niches.join(', ')}` : null,
    '',
    `Looking forward to the partner details.`,
  ]
    .filter((line): line is string => line !== null)
    .join('\n')
}
